var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYearBuild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.008,
    height: 20,
    viewBox: "0 0 20.008 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29328",
    d: "M28.4 9.24a10.252 10.252 0 0 0-3.729-3.953 10.909 10.909 0 0 0-8.8-1.125 10.158 10.158 0 0 0-6.464 5.647l.8.319a9.054 9.054 0 0 1 3.511-3.9 9.632 9.632 0 0 1 10.2.131 8.811 8.811 0 0 1 3.167 3.6l-1 .546 2.982 1.195.342-3.017z",
    transform: "translate(-9.402 -3.702)",
    style: {
      fill: "#323233"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29329",
    d: "M4.081 78.072a10.253 10.253 0 0 0 3.73 3.953 10.911 10.911 0 0 0 8.806 1.125 10.159 10.159 0 0 0 6.455-5.65l-.8-.319a9.054 9.054 0 0 1-3.511 3.9 9.634 9.634 0 0 1-10.2-.131 8.812 8.812 0 0 1-3.168-3.6l1-.546L3.41 75.61l-.342 3.017z",
    transform: "translate(-3.068 -63.61)",
    style: {
      fill: "#323233"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29330",
    d: "m7 41.982-7 5.475L1.467 49.4l.718-.562v4.348h9.631v-4.352l.718.562L14 47.457zm.7 10.365H6.3v-2.986h1.4zm3.3 0H8.519v-3.821H5.481v3.821H3.006v-4.156L7 45.067l3.994 3.124v4.156zm1.389-4.123-.568-.444-.952-.745L7 44.014l-5.383 4.21-.465-.615L7 43.036l5.848 4.574z",
    transform: "translate(2.952 -37.985)",
    style: {
      fill: "#323233"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearBuild);
export default __webpack_public_path__ + "static/media/yearBuild.b9167fa63a5b9ca63d9bcd2cf47308f5.svg";
export { ForwardRef as ReactComponent };